import React from 'react';
import { useImage } from '../../hooks/useImage';
import TitleDividedWithDescription from '../title-divided-with-description/title-divided-with-description';
import './title-divided-with-description-and-image.scss';

function TitleDividedWithDescriptionAndImage({ content, extraContentClassName }) {
  const { title, items, image, link } = content;
  const imageRender = useImage(image);
  return (
    <TitleDividedWithDescription title={title} items={items} link={link} extraContentClassName={extraContentClassName}>
      <div className='image'>{imageRender}</div>
    </TitleDividedWithDescription>
  );
}

export default TitleDividedWithDescriptionAndImage;
